module.exports = __webpack_public_path__ + "static/media/blog-3.51f152dd.svg";